import Vue from 'vue';

const transform = Vue.directive('transform', function(el,bind,vNode) {
    console.log(el);
})

const showDataOnly = Vue.filter('showDataOnly', function(val){
    let newVal = val.replace(/(\d{4}-\d{2}-\d{2} \d{2}:\d{2})(.+)/g, '$1');
    return newVal
});
const disabled = Vue.directive('disabled', {
    bind(arm) {
      const el = arm;
      el.style.backgroundColor = '#ccc';
    },
    update(arm1, arm2) {
      const el = arm1;
      const binding = arm2;
      if (binding.value) {
        el.style.backgroundColor = '#ccc';
      } else {
        el.style.background = '#0095f7';
      }
    },
  });


export {
    transform, showDataOnly, disabled,
}